var map = {
	"./apple-cider.jpg": "3388",
	"./kasundi.jpg": "50f7",
	"./soya-sauce.jpg": "b850",
	"./white-vinegar.jpg": "de98",
	"./yellow-mustard.jpg": "a511"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1399";